<p-skeleton
  *ngIf="loading"
  #skeleton
  height="2rem"
  width="200px"
  class="flex"></p-skeleton>
<span class="p-calendar-atom" [ngClass]="{ hidden: loading }">
  <p-calendar
    #calendar
    [readonlyInput]="readonlyInput"
    showIcon="true"
    (onSelect)="handleSelect($event)"
    (onClose)="handleClose($event)"
    (onBlur)="handleBlur($event)"
    (onInput)="handleInput($event)"
    (onFocus)="handleFocus($event)"
    (onClearClick)="handleClearClick($event)"
    dateFormat="dd/mm/yy"
    appendTo="body"
    inputId="icondisplay"
    [iconDisplay]="'input'"
    [disabled]="isDisabled"
    [style]="style"
    [styleClass]="styleClass"
    [(ngModel)]="valueCalendar"
    [placeholder]="placeholder"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [touchUI]="touchUI"
    [showButtonBar]="showButtonBar"
    [yearNavigator]="yearNavigator"
    [monthNavigator]="monthNavigator"
    [showOtherMonths]="showOtherMonths"
    [disabledDates]="disabledDates"
    [required]="required">
  </p-calendar>
</span>
